import React, { type PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'
import { Auth0Provider, type AppState } from '@auth0/auth0-react'

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode
}

export const Auth0ProviderWithNavigate = ({
  children,
}: PropsWithChildren<Auth0ProviderWithNavigateProps>): JSX.Element | null => {
  const navigate = useNavigate()

  const domain = process.env.REACT_APP_AUTH0_DOMAIN
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const redirectUri = window.location.origin + (process.env.REACT_APP_AUTH0_CALLBACK_URL ?? '')
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onRedirectCallback = (appState?: AppState) => {
    const returnUri = appState?.returnTo ?? window.location.pathname
    navigate(returnUri)
  }

  if (!((domain != null) && (clientId != null) && (redirectUri != null) && (audience != null))) {
    return null
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithNavigate
